import { Box } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { useAtom } from 'jotai';

import { isDrawerOpen as isDrawerOpenAtom } from 'atoms/drawer';
import logo from 'assets/logo-full.svg';
import { drawerWidth } from 'utils/constants';

const Logo = () => {
  const [isDrawerOpen, setDrawerOpen] = useAtom(isDrawerOpenAtom);

  const handleDrawerToggle = () => {
    setDrawerOpen(!isDrawerOpen);
  };

  return (
    <Box
      sx={{
        width: { xs: '100%', md: drawerWidth },
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        px: '22px',
        position: 'relative',
      }}
    >
      <IconButton color="inherit" aria-label="open drawer" onClick={handleDrawerToggle} edge="start">
        <MenuIcon />
      </IconButton>
      <Box
        component="img"
        sx={{
          height: 25,
          position: { xs: 'absolute', md: 'static' },
          left: { xs: '50%', md: 'auto' },
          transform: { xs: 'translateX(-50%)', md: 'none' },
        }}
        alt="Booking Plus"
        src={logo}
      />
    </Box>
  );
};

export default Logo;
